import { render, staticRenderFns } from "./EditRefundDialog.vue?vue&type=template&id=10da1854&"
import script from "./EditRefundDialog.vue?vue&type=script&lang=js&"
export * from "./EditRefundDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports